import { ChartColorTheme } from '@/constants/chartThemes';

export const getChartOverrides = (theme: ChartColorTheme) => ({
  'candleStyle.upColor': theme.colors.upColor,
  'candleStyle.downColor': theme.colors.downColor,
  'candleStyle.wickUpColor': theme.colors.wickUpColor,
  'candleStyle.wickDownColor': theme.colors.wickDownColor,
  'candleStyle.borderUpColor': theme.colors.borderUpColor,
  'candleStyle.borderDownColor': theme.colors.borderDownColor,
  'candleStyle.volumeUpColor': theme.colors.volumeUpColor,
  'candleStyle.volumeDownColor': theme.colors.volumeDownColor,
  'plotLineColor.priceLine.long': theme.colors.longLineColor,
  'plotLineWidth.priceLine.long': 2,
  'plotLineColor.priceLine.short': theme.colors.shortLineColor,
  'plotLineWidth.priceLine.short': 2,
  'mainSeriesProperties.showCountdown': true,
});

export const applyChartTheme = (chartWidget: any, theme: ChartColorTheme) => {
  if (!chartWidget) return;

  const overrides = getChartOverrides(theme);

  try {
    chartWidget.applyOverrides(overrides);

    // Volume 인디케이터 색상 실시간 적용
    chartWidget.activeChart().getAllStudies().forEach((study: any) => {
      if (study.name === 'Volume' || study.name.toLowerCase().includes('volume')) {
        chartWidget.activeChart().getStudyById(study.id).applyOverrides({
          'volume.color.0': theme.colors.volumeDownColor,
          'volume.color.1': theme.colors.volumeUpColor,
        });
      }
    });

    console.log('[Chart Theme] Applied theme:', theme.name);
  } catch (error) {
    console.error('[Chart Theme] Failed to apply theme:', error);
  }
};
